import React, {Component} from "react";
import { Popconfirm} from "antd";

import BaseComponent from "../../../../../base/BaseComponent";

export default class MenuTableOperation extends BaseComponent {

    render() {
        let {data, showMenuEdit, deleteMenu, unboundPermissionByCode} = this.props;
        const type = data.type * 1;
        return (
            <>
                {
                    type === 1 ?
                        <>
                            <span className="cm-link margin-right-15"
                                  onClick={() => showMenuEdit(data)}>修改</span>
                            <Popconfirm
                                title={`确定删除菜单：${data.menuName}`}
                                onConfirm={() => deleteMenu(data)}
                                okText="确定"
                                cancelText="取消"
                            >
                                <span className="cm-link">删除</span>
                            </Popconfirm>
                        </> : null
                }
                {
                    type === 2 ? <Popconfirm
                        title={`确定解绑权限：${data.code}`}
                        onConfirm={() => unboundPermissionByCode(data)}
                        okText="确定"
                        cancelText="取消"
                    >
                        <span className="cm-link">解绑</span>
                    </Popconfirm> : null
                }

            </>
        );
    }
}
